"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPause = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M8 19V5c0-.667.333-1 1-1s1 .333 1 1v14c0 .667-.333 1-1 1s-1-.333-1-1zm6 0V5c.005-.667.34-1 1.004-1 .664 0 .996.333.996 1v14c0 .667-.333 1-1 1s-1-.333-1-1z' }))); };
exports.default = SvgPause;
//# sourceMappingURL=Pause.js.map